import { Link } from "react-router-dom";

const allowedRoutes = new Set(["/my-profile", "/account-settings", "/support#contact"]);

export default function SupportReply({ text, onNavigate }) {
  const parts = String(text || "").split(/(\[[^\]]+\]\((?:\/my-profile|\/account-settings|\/support#contact)\))/g);
  return parts.map((part, index) => {
    const match = part.match(/^\[([^\]]+)\]\((\/[^)]+)\)$/);
    if (!match || !allowedRoutes.has(match[2])) return part;
    const [path, hash] = match[2].split("#");
    return <Link key={`${match[2]}-${index}`} to={hash ? `${path}#${hash}` : path} onClick={onNavigate}>{match[1]}</Link>;
  });
}
